import $ from 'jquery';
import FJConfig from '../config/FJConfig';
import Download from '../lib/download';
import FJLocalStore from '../store/FJLocalStore';

let loginCallback = [];
let fUserID = '';
let fProjectID = '';
let timer = {};

export default {
    getCurrentUrl: function () {
        let lange = FJLocalStore.currentTag();
        let url = '';
        if (lange === 'en' || lange === 'it') {
            url = FJConfig.serverPath;
        } else {
            url = FJConfig.serverPath + '/' + lange;
        }
        return url;
    },

    // getJumpUrl: function (url) {
    //     let tag = window.language_tag === 'en' ? '/' : '/' + window.language_tag
    //     let URL = tag + url
    //     return URL
    // },
    moveEnd: function (obj) {
        obj.focus();
        let len = obj.value.length;
        if (document.selection) {
            let sel = obj.createTextRange();
            sel.moveStart('character', len);
            sel.collapse();
            sel.select();
            console.log(1);
        } else if (typeof obj.selectionStart === 'number' && typeof obj.selectionEnd === 'number') {
            obj.selectionStart = obj.selectionEnd = len;
            console.log(2);
        }
    },
    filterStr: function (str) {
        return str.replace(/<script>|<\/script>/g, '');
    },
    getSelectionLength: function (myField) {
        return myField.selectionEnd - myField.selectionStart;
    },
    insertAtCursor: function (myField, myValue) {
        // IE support
        if (document.selection) {
            myField.focus();
            let sel = document.selection.createRange();
            sel.text = myValue;
        }
        // MOZILLA and others
        else if (myField.selectionStart || myField.selectionStart === 0) {
            let startPos = myField.selectionStart;
            let endPos = myField.selectionEnd;
            myField.value =
                myField.value.substring(0, startPos) + myValue + myField.value.substring(endPos, myField.value.length);
        } else {
            myField.value += myValue;
        }

        return myField.value;
    },
    setShareUserID: function (id) {
        fUserID = id;
    },
    getShareUserID: function () {
        return fUserID;
    },
    setShareProjectID: function (id) {
        fProjectID = id;
    },
    getShareProjectID: function () {
        return fProjectID;
    },
    getUserId: function () {
        return window.fjuser && window.fjuser.info && window.fjuser.info.id
            ? window.fjuser && window.fjuser.info && window.fjuser.info.id
            : '';
    },
    getQueryString: function (name) {
        let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
        let r = window.location.search.substr(1).match(reg); //获取url中"?"符后的字符串并正则匹配
        let context = '';
        if (r != null) context = decodeURIComponent(r[2]);
        reg = null;
        r = null;
        return context == null || context === '' || context === 'undefined' ? '' : context;
    },
    getLanguage: function (tag, callback) {
        fetch(FJConfig.languagePath + tag + '.json?v=' + FJConfig.buildVersion)
            .then(res => res.json())
            .then(json => {
                callback(json);
            })
            .catch(err => console.log(err));
    },
    addEvent: function (element, event, handler, useCapture = false) {
        if (!element) {
            return;
        }
        if (element.addEventListener) {
            element.addEventListener(event, handler, useCapture);
        } else if (element.attachEvent) {
            element.attachEvent('on' + event, handler);
        }
    },
    removeEvent: function (element, event, handler, useCapture = false) {
        if (!element) {
            return;
        }
        if (element.removeEventListener) {
            element.removeEventListener(event, handler, useCapture);
        } else if (element.detachEvent) {
            element.detachEvent('on' + event, handler);
        }
    },
    formatTime: function (time) {
        let m = Math.floor(time / 60);
        let s = Math.floor(time % 60);
        if (s < 10) s = '0' + s;
        return m + ':' + s;
    },
    valueOfInterval(value, min, max) {
        let result = 0;
        result = value < min ? min : value;
        result = result > max ? max : result;
        return result;
    },
    isPanelArea: function (e, object) {
        if (!e) {
            return false;
        }
        let point = {
            x: e.clientX,
            y: e.clientY,
        };

        try {
            let rect = {
                x: object.getBoundingClientRect().left,
                y: object.getBoundingClientRect().top,
                width: $(object).outerWidth(),
                height: $(object).outerHeight(),
            };
            return this.isPointInRect(point, rect);
        } catch (e) {
            return false;
        }
    },
    isPointInRect: function (point, rect) {
        if (point.x >= rect.x && point.x <= rect.x + rect.width && point.y >= rect.y && point.y <= rect.y + rect.height)
            return true;
        return false;
    },
    isLocalhost: function () {
        return Boolean(
            window ||
                window.location.hostname === 'localhost' ||
                // [::1] is the IPv6 localhost address.
                window.location.hostname === '[::1]' ||
                // 127.0.0.1/8 is considered localhost for IPv4.
                window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/) ||
                window.location.hostname.match(/^192.168(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){2}$/),
        );
    },
    isLogin: function () {
        return window.fjuser && window.fjuser.info && window.fjuser.info.id;
    },
    anonymousSignUp: function () {
        return new Promise((resolve, reject) => {
            if (window.PanelFunc && window.PanelFunc.showSignUpPane) {
                window.PanelFunc.showSignUpPane();
                window.loginToCreateProjectCallback = () => {
                    loginCallback.forEach(callback => {
                        callback();
                    });
                    resolve();
                };
            } else {
                reject(new Error('error in anonymousSignUp'));
            }
        });
    },
    downloadVideo: function (videoUrl) {
        if (this.getBrowser() === 'FF') {
            Download(videoUrl);
        } else {
            const save_link = document.createElementNS('http://www.w3.org/1999/xhtml', 'a');
            save_link.href = videoUrl;
            save_link.click();
        }
    },
    copy: function (text) {
        const input = document.createElement('input');
        document.body.appendChild(input);
        input.value = text; // 修改文本框的内容
        input.select(); // 选中文本
        document.execCommand('copy'); // 执行浏览器复制命令
        document.body.removeChild(input);
    },
    toLocalTime: function (time) {
        return time - new Date(time).getTimezoneOffset() * 60000;
    },
    formatTimeZone: function (time) {
        let date = new Date(time);
        const month = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        let Y = date.getFullYear() + ' ';
        let M = month[date.getMonth()] + ' ';
        let D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ', ';
        // h = (date.getHours() < 10 ? '0'+date.getHours() : date.getHours()) + ':';
        // m = (date.getMinutes() < 10 ? '0'+date.getMinutes() : date.getMinutes()) + ':';
        // s = (date.getSeconds() < 10 ? '0'+date.getSeconds() : date.getSeconds());
        return M + D + Y;
    },
    /**
     * @desc 转换时间格式
     * @param {string} date - 例如2020-07-03 06:35:55
     * @return {number}
     */
    convertTime: function (date) {
        let newDate = date.substring(0, 19);
        newDate = newDate.replace(/-/g, '/');
        return new Date(newDate).getTime();
    },
    /**
     * @description 格式化数字（货币格式）
     * @param num
     * @returns {string}
     */
    toThousands: function (num) {
        return (num || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
    },

    /**
     * @description 判断是不是测试环境
     * @returns {boolean}
     */
    isTest: function () {
        return process.env.NEXT_PUBLIC_SERVER_TAG_NODE !== 'release';
    },

    /**
     * @description 判断是否是手机端访问
     * @returns {boolean}
     */
    isMobile: function () {
        const ua = navigator.userAgent.toLowerCase();
        if (ua.match(/mobile/)) {
            return true;
        }
        return false;
    },

    /**
     * @desc 获取当前浏览器
     * @return {string}
     */
    getBrowser: function () {
        const userAgentDataBrowserList = ['Google Chrome', 'Opera', 'Microsoft Edge'];
        if (navigator && navigator.userAgentData) {
            const userAgentData = navigator.userAgentData;
            const isMobile = userAgentData.mobile ? '.Mobile' : '';
            const brands = userAgentData.brands;

            let browser = '';
            for (let i = 0; i < brands.length; i++) {
                const brand = brands[i].brand;
                if (userAgentDataBrowserList.indexOf(brand) !== -1) {
                    switch (brand) {
                        case userAgentDataBrowserList[0]: {
                            browser = 'Chrome' + isMobile;
                            break;
                        }
                        case userAgentDataBrowserList[1]: {
                            browser = 'Opera' + isMobile;
                            break;
                        }
                        case userAgentDataBrowserList[2]: {
                            browser = 'Edge' + isMobile;
                            break;
                        }
                    }
                    break;
                }
            }

            if (browser) {
                return browser;
            }
        }

        let Sys = {};
        let ua = navigator.userAgent.toLowerCase();
        let s;
        let isMobile = '';

        // eslint-disable-next-line no-unused-expressions
        (s = ua.match(/rv:([\d.]+)\) like gecko/))
            ? (Sys.ie = s[1])
            : (s = ua.match(/msie ([\d.]+)/))
            ? (Sys.ie = s[1])
            : (s = ua.match(/edge\/([\d.]+)/))
            ? (Sys.edge = s[1])
            : (s = ua.match(/edg\/([\d.]+)/))
            ? (Sys.edge = s[1])
            : (s = ua.match(/firefox\/([\d.]+)/))
            ? (Sys.firefox = s[1])
            : (s = ua.match(/opera.([\d.]+)/))
            ? (Sys.opera = s[1])
            : (s = ua.match(/opr\/([\d.]+)/))
            ? (Sys.opera = s[1])
            : (s = ua.match(/chrome\/([\d.]+)/))
            ? (Sys.chrome = s[1])
            : (s = ua.match(/version\/([\d.]+).*safari/))
            ? (Sys.safari = s[1])
            : 0;

        if (ua.match(/mobile/)) {
            isMobile = '.Mobile';
        }

        if (Sys.ie) return 'IE' + isMobile;
        if (Sys.edge) return 'Edge' + isMobile;
        if (Sys.firefox) return 'FF' + isMobile;
        if (Sys.opera) return 'Opera' + isMobile;
        if (Sys.safari) return 'Safari' + isMobile;
        if (Sys.chrome) return 'Chrome' + isMobile;
    },

    /**
     * @description 埋点统计
     * @param eventType
     * @param eventData
     */
    ealog: function (eventType, eventData) {
        if (window && window.ealog && window.ealog.addEvent) {
            window.ealog.addEvent(eventType, eventData);
        }
    },

    getBaseUrl: function () {
        let paramVal = this.getQueryString('page');
        let actionVal = this.getQueryString('action');

        // action 现在有两个参数，一个是billing，一个是privacy-settings
        if (paramVal) {
            let page;
            switch (paramVal) {
                case 'profile':
                    page = '/profile.html';
                    break;
                default:
                    page = '/editor/';
            }
            if (actionVal) {
                page = `${page}?action=${actionVal}`;
            }
            return this.getCurrentUrl() + page;
        } else {
            return this.getCurrentUrl() + '/editor/';
        }
    },

    /**
     * @description 轮询
     * @param checker - 检查函数
     * @param interval - 轮询间隔时间（ms）
     * @param timeout - 最大轮询时间（ms）
     * @param throwErrorTimeout - 是否在在 timeout 时抛出错误
     * @return {Promise<void>}
     */
    polling: async function (checker, interval = 1, timeout = 2000, throwErrorTimeout) {
        const oldTime = performance.now();
        const isTimeout = () => {
            const out = performance.now() - oldTime >= timeout;
            if (throwErrorTimeout && out) {
                throw new Error('POLLING_TIMEOUT');
            }
            return out;
        };
        while (!checker() && !isTimeout()) {
            await this.wait(interval / 1000);
        }
    },

    wait: function (seconds = 0.3) {
        return new Promise(resolve => {
            setTimeout(resolve, seconds * 1000);
        });
    },

    /**
     * @description 倒计时功能
     * @param name
     * @param time 默认60秒
     * @param cb
     * @returns {function(): undefined}
     */
    countDown: function (name, time = 60, cb) {
        let remainingTime;
        return function () {
            // 如果已经运行则直接返回
            if (timer[name]) {
                return;
            }

            remainingTime = time;
            timer[name] = setInterval(() => {
                if (cb) {
                    cb(remainingTime);
                }
                if (remainingTime === 0) {
                    clearInterval(timer[name]);
                    timer[name] = null;
                }
                remainingTime--;
            }, 1000);
        };
    },
};
